import type { MailboxInfo } from "owa-client-types";
import { isAccountExplicitLogon } from "owa-account-shared-mailbox-utils";

/**
 * Determines whether to filter for addins that support shared folders based on account logon status.
 *
 * @param mailboxInfo - The mailbox information to check
 * @returns true if the account is explicitly logged on, false otherwise
 */
export default function shouldFilterSupportsSharedFolders(mailboxInfo: MailboxInfo): boolean {
    return isAccountExplicitLogon(mailboxInfo);
}
